var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7001E"
    },
    d: "M344,160c-4.422,0-8-3.582-8-8v-48c0-44.113-35.891-80-80-80s-80,35.887-80,80v48 c0,4.418-3.578,8-8,8s-8-3.582-8-8v-48c0-52.934,43.063-96,96-96s96,43.066,96,96v48C352,156.418,348.422,160,344,160z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4F19"
    },
    d: "M475.219,411.84l-25.68-184c-6.031-43.234-43.5-75.84-87.148-75.84H149.609 c-43.648,0-81.117,32.605-87.148,75.84l-25.68,184c-3.523,25.227,4.055,50.715,20.773,69.926 C74.273,500.98,98.469,512,123.938,512h264.125c25.469,0,49.664-11.02,66.383-30.234 C471.164,462.555,478.742,437.066,475.219,411.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7001E"
    },
    d: "M362.391,152H149.609c-9.632,0-18.928,1.669-27.687,4.608l22.788,141.869 C149.734,324.855,172.867,344,199.719,344h112.563c26.852,0,49.984-19.145,55.047-45.75l22.749-141.642 C381.319,153.669,372.022,152,362.391,152z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEE43"
    },
    d: "M304,304h-96c-8.837,0-16-7.163-16-16v0c0-8.837,7.163-16,16-16h96c8.837,0,16,7.163,16,16v0 C320,296.837,312.837,304,304,304z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD100"
    },
    d: "M192,384L192,384c0-8.837,7.163-16,16-16h0c8.837,0,16,7.163,16,16v0c0,8.837-7.163,16-16,16h0 C199.163,400,192,392.837,192,384z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD100"
    },
    d: "M192,448L192,448c0-8.837,7.163-16,16-16h0c8.837,0,16,7.163,16,16v0c0,8.837-7.163,16-16,16h0 C199.163,464,192,456.837,192,448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD100"
    },
    d: "M288,384L288,384c0-8.837,7.163-16,16-16h0c8.837,0,16,7.163,16,16v0c0,8.837-7.163,16-16,16h0 C295.163,400,288,392.837,288,384z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD100"
    },
    d: "M288,448L288,448c0-8.837,7.163-16,16-16h0c8.837,0,16,7.163,16,16v0c0,8.837-7.163,16-16,16h0 C295.163,464,288,456.837,288,448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4F19"
    },
    d: "M323.891,64c-4.605,0-9.18-1.98-12.344-5.813C297.801,41.547,277.555,32,256,32 s-41.801,9.547-55.547,26.188c-5.637,6.816-15.719,7.773-22.523,2.148c-6.816-5.625-7.777-15.711-2.148-22.523 C195.625,13.781,224.867,0,256,0s60.375,13.781,80.219,37.813c5.629,6.813,4.668,16.898-2.148,22.523 C331.09,62.801,327.48,64,323.891,64z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD100"
    },
    d: "M152,152c0-8.837,7.163-16,16-16c8.837,0,16,7.163,16,16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD100"
    },
    d: "M328,152c0-8.837,7.163-16,16-16c8.837,0,16,7.163,16,16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.673ce42ee5440f10f6052b72a3ad70a0.svg";
export { ForwardRef as ReactComponent };